// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Contact: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 23 26"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fillRule="evenodd"
                d="M19.638 3.326a11 11 0 011.437 1.74c.411.617.762 1.27 1.053 1.954.292.685.508 1.393.655 2.121.145.728.217 1.471.217 2.234v10.563c0 .675-.239 1.252-.718 1.726-.48.473-1.06.711-1.746.711h-4.234a2.424 2.424 0 01-.9 1.168 2.412 2.412 0 01-1.438.457 2.4 2.4 0 01-1.746-.71 2.347 2.347 0 01-.718-1.727c0-.679.241-1.253.718-1.727a2.39 2.39 0 011.746-.711c.53 0 1.01.152 1.437.457.43.303.727.694.9 1.168h4.235c.223 0 .416-.08.578-.24a.784.784 0 00.243-.573v-2.565a5.533 5.533 0 01-.41.089 2.208 2.208 0 01-.411.039 2.4 2.4 0 01-1.746-.71 2.347 2.347 0 01-.719-1.727v-3.25c0-.679.241-1.253.719-1.727a2.39 2.39 0 011.746-.711c.138 0 .27.013.398.037.127.026.261.056.397.089v-.126a9.209 9.209 0 00-.988-3.503 9.961 9.961 0 00-2.155-2.832 10.107 10.107 0 00-3.043-1.905 9.585 9.585 0 00-3.645-.697 9.593 9.593 0 00-3.645.697c-1.146.466-2.16 1.1-3.043 1.905a9.961 9.961 0 00-2.155 2.832 9.248 9.248 0 00-.988 3.503v.126c.136-.033.27-.063.399-.09.127-.023.26-.036.396-.036.686 0 1.266.236 1.746.71.48.475.719 1.05.719 1.727v3.25c0 .676-.24 1.253-.719 1.727-.48.473-1.06.711-1.746.711a2.4 2.4 0 01-1.746-.71A2.347 2.347 0 010 17.062v-5.688c0-.763.072-1.506.219-2.234.145-.728.364-1.436.655-2.121.29-.685.642-1.337 1.051-1.954a11.12 11.12 0 011.437-1.74 11.072 11.072 0 011.76-1.421A12.16 12.16 0 017.096.862 11.26 11.26 0 019.242.215 11.82 11.82 0 0111.5 0c.771 0 1.522.071 2.258.214.736.146 1.453.36 2.145.648a12.16 12.16 0 011.976 1.042c.624.406 1.211.88 1.759 1.422"
            />
        </svg>
    );
};

export default React.memo(Contact);
